export default __webpack_public_path__ + "static/media/truck.603d7348.svg";